//节流函数 第一次点击时马上触发 在延迟时间内再次点击不会触发
const throttle = function (callback, delayTime) {
  if (typeof callback !== 'function') {
    throw new TypeError('callback不是函数')
  }
  let timeId = undefined
  let self = this
  return function () {
    if (timeId !== undefined) {
      return
    }
    callback.apply(self, arguments)
    timeId = setTimeout(() => {
      timeId = undefined
    }, delayTime)
  }
}
/* 防抖 输出在前  防抖在后 */
const debounceLast = function (fn, delay) {
  if (typeof fn !== 'function') {
    throw new TypeError('fn不是函数')
  }
  let timer // 维护一个 timer
  return function () {
    var _this = this // 取debounce执行作用域的this(原函数挂载到的对象)
    var args = arguments
    if (timer) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(_this, args) // 用apply指向调用debounce的对象，相当于_this.fn(args);
        timer = null
      }, delay)
    } else {
      fn.apply(_this, args) // 用apply指向调用debounce的对象，相当于_this.fn(args);
      timer = setTimeout(function () {
        timer = null
      }, delay)
    }
  }
}
const debounce = function (func, delay) {
  let timer
  return function () {
    const context = this
    const args = arguments

    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}
const deepClone = function (obj) {
  //可传入对象 或 数组
  //  判断是否为 null 或 undefined 直接返回该值即可,
  if (obj === null || !obj) return obj
  // 判断 是要深拷贝 对象 还是 数组
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    //对象字符串化的值会为 "[object Object]"
    let target = {} //生成新的一个对象
    const keys = Object.keys(obj) //取出对象所有的key属性 返回数组 keys = [ ]
    //遍历复制值, 可用 for 循环代替性能较好
    keys.map((item, index) => {
      if (obj[item] && typeof obj[item] === 'object')
        //如果遇到的值又是 引用类型的 [ ] {} ,得继续深拷贝
        target[item] = deepClone(obj[item])
      //递归
      else target[item] = obj[item]
    })
    return target //返回新的对象
  } else if (Array.isArray(obj)) {
    // 数组同理
    let arr = []
    obj.map((item, index) => {
      if (item && typeof item === 'object') {
        arr[index] = deepClone(item)
      } else {
        arr[index] = item
      }
    })
    return arr
  }
}
// 获取hash链接中的参数
const getUrlQuery = function (val, url) {
  const w = url.indexOf('?')
  const query = url.substring(w + 1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == val) {
      return pair[1]
    }
  }
  return ''
}
/* 拼接url */
const ConcatUrl = function (url, param) {
  let haswenhao = url.includes('?')
  if (haswenhao) {
  } else {
  }
  return
}
//是否是ios
const isIOS = function () {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}
export {
  throttle,
  deepClone,
  debounceLast,
  getUrlQuery,
  isIOS,
  debounce,
  ConcatUrl
}
